import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const workflowSchemeConfigEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(() => {
		if (!__SERVER__) {
			return import(
				/* webpackChunkName: "async-project-settings-workflow-scheme-config", jiraSpaEntry: "async-project-settings-workflow-scheme-config" */ './src'
			);
		}
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return Promise.resolve({ default: () => null }) as unknown as Promise<{
			default: typeof import('./src').default;
		}>;
	}),
	getPreloadProps: () => ({}),
});
